<template lang="html">
  <ul class="order-section">
    <orderListItem
      v-for="(order, i) in items"
      :order="order"
      :key="order.orderId"
      :index="i"
      v-on:operation="refreshData"
    ></orderListItem>
  </ul>
</template>

<script>
import orderListItem from './orderListItem'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  provide() {
    return {
      /** 我的相册点击事件埋点参数 */
      myAlbumTrackParams: {
        bizType: '127',
        pageLevelId: '121013096',
        clickId: '200004'
      }
    }
  },
  methods: {
    refreshData(index) {
      this.items.splice(index, 1)
    }
  },
  components: {
    orderListItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.order-section {
  display: block;
  padding-bottom: rem(60px);
}
</style>
